// extracted by mini-css-extract-plugin
export default {"wrapper":"Index_wrapper__Fq0bW"};